import { Validator } from "vee-validate";
const paramNames = ["allowedIssuers", "issuer"];
const allowed = Validator.extend(
  "allowed",
  {
    validate(value, paramNames) {
      let issuer = paramNames.slice(-1).toString();
      let allowedIssuers = paramNames.slice(0, -1);

      allowedIssuers = allowedIssuers.map((v) => v.toLowerCase());
      return allowedIssuers.includes(issuer);
    },
  },
  paramNames
);

export default allowed;
